export const LogoMark = ({ size = 36 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="syntera-g" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#00F0FF" />
                <stop offset="1" stopColor="#2563EB" />
            </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#0D111A" stroke="rgba(255,255,255,0.08)" />
        <path
            d="M41 21.5c-2.2-3.1-5.9-5-10-5-6 0-10.5 3.8-10.5 8.8 0 12.2 21 6.6 21 15.9 0 5.2-4.7 9-10.5 9-4.8 0-8.7-2.4-10.6-5.9"
            stroke="url(#syntera-g)"
            strokeWidth="5"
            strokeLinecap="round"
        />
    </svg>
);

export const Logo = () => (
    <div className="flex items-center gap-2.5" data-testid="syntera-logo">
        <LogoMark />
        <span className="font-syne text-lg font-bold tracking-tight text-white">
            Syntera <span className="text-volt">Technologies</span>
        </span>
    </div>
);
